import s from './Table.module.css'

type Props = {
  data: Record<string, string | React.ReactNode>[]
}

const Table = ({ data }: Props) => {
  return (
    <table className={s.table}>
      <thead className={s.head}>
        <tr className={s.row}>
          {data[0] &&
            Object.keys(data[0]).map(header => (
              <th key={header} className={s.cell}>
                {header}
              </th>
            ))}
        </tr>
      </thead>
      <tbody className={s.body}>
        {data.map((row, rowIndex) => (
          <tr key={rowIndex} className={s.row}>
            {row &&
              Object.keys(row).map((key, cellIndex) => (
                <td key={cellIndex} className={s.cell}>
                  {row[key]}
                </td>
              ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default Table
